/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".payment-text{font-size:14px}.payment-text p{margin:0 0 10px}#payment-framewrap{border:1px solid #ccc}#payment-framewrap iframe{border:none;width:100%;height:550px}"];
export { styles as styles };
